module.exports = __webpack_public_path__ + "img/1-(2).da6baca5.jpg";